// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles__logo___2p6TW","buttonLabel":"styles__buttonLabel___2hZR0"};